import { media, typography } from "../../../../styles";
import React, { useEffect, useRef } from "react";
import SelectableButton, { SelectableButtonProps } from "../../../SelectableButton/SelectableButton";
import styled, { css } from "styled-components";
import { applyOpacity } from "../../../../styles/utils";
export type DateButtonProps = SelectableButtonProps & {
  column?: number;
  focused?: boolean;
  today?: boolean;
  unavailable?: boolean;
};
const unavailableStyles = css`
  color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.2)} !important;
  background: ${({
  theme
}) => theme.colours.white} !important;
  border: none !important;
  cursor: default !important;
`;
export const StyledSelectableButton = styled(SelectableButton)<DateButtonProps>`
  ${({
  column
}) => column !== undefined ? css`
          grid-column-start: ${column};
        ` : null};

  width: 100%;
  height: 2.875rem;
  border: none;
  ${typography.body}

  @media ${media.hoverable} {
    &:hover {
      color: ${({
  theme
}) => theme.colours.primaryText};
      box-shadow: none;
      background: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.05)};
      border: 2px solid ${({
  theme
}) => theme.colours.primaryText};
    }
  }
  &:active {
    box-shadow: none;
    background: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.05)};
  }
  &:focus {
    border: 2px solid ${({
  theme
}) => theme.colours.primaryText};
  }

  ${({
  unavailable
}) => unavailable ? unavailableStyles : null}
  ${({
  selected,
  today
}) => today && !selected ? css`
          ${typography.bodyBold};
        ` : null}
`;
export function DateButton({
  focused,
  ...props
}: DateButtonProps) {
  const ref = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (ref.current && focused) {
      ref.current.focus({
        preventScroll: true
      });
    }
  }, [focused]);
  return <StyledSelectableButton {...props} ref={ref} data-sentry-element="StyledSelectableButton" data-sentry-component="DateButton" data-sentry-source-file="DateButton.tsx" />;
}
export default DateButton;